import { createSelector } from "reselect";
import getOrganization from "./get_organization";

const getOrganizationName = createSelector([
  getOrganization
], (organization) => organization?.name || null);

export default getOrganizationName;
